import memoize from 'lodash/memoize'

const isExecutedThroughJest = memoize((): boolean => {
  try {
    return !!process?.env?.JEST_WORKER_ID
  } catch {
    return false
  }
})

export default {
  __DEV__: !!__DEV__,
  __TEST__: isExecutedThroughJest(),
}
